import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';
export const styles = createElement(SVG, {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, createElement(Path, {
  d: "M12 4c-4.4 0-8 3.6-8 8v.1c0 4.1 3.2 7.5 7.2 7.9h.8c4.4 0 8-3.6 8-8s-3.6-8-8-8zm0 15V5c3.9 0 7 3.1 7 7s-3.1 7-7 7z"
}));
export default styles;
//# sourceMappingURL=styles.js.map